//
//
//
//
// 单个仪表盘
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '240px'
    },
    top: {
      type: String,
      default: '40px'
    },
    left: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {
    var _this = this;

    // console.log('dial')
    setTimeout(function () {
      _this.initBarChart();
    }, 1000); // this.$nextTick(() => {})
  },
  methods: {
    initBarChart: function initBarChart(data, title, color) {
      //跳转代码
      var colorList = [['#ff7f50', '#87cefa', '#da70d6', '#32cd32', '#6495ed', '#ff69b4', '#ba55d3', '#cd5c5c', '#ffa500', '#40e0d0', '#1e90ff', '#ff6347', '#7b68ee', '#d0648a', '#ffd700', '#6b8e23', '#4ea397', '#3cb371', '#b8860b', '#7bd9a5'], ['#ff7f50', '#87cefa', '#da70d6', '#32cd32', '#6495ed', '#ff69b4', '#ba55d3', '#cd5c5c', '#ffa500', '#40e0d0', '#1e90ff', '#ff6347', '#7b68ee', '#00fa9a', '#ffd700', '#6b8e23', '#ff00ff', '#3cb371', '#b8860b', '#30e0e0'], ['#929fff', '#9de0ff', '#ffa897', '#af87fe', '#7dc3fe', '#bb60b2', '#433e7c', '#f47a75', '#009db2', '#024b51', '#0780cf', '#765005', '#e75840', '#26ccd8', '#3685fe', '#9977ef', '#f5616f', '#f7b13f', '#f9e264', '#50c48f']][2];
      var option = {
        // 图表标题
        title: {
          show: false,
          //显示策略，默认值true,可选为：true（显示） | false（隐藏）
          text: '"新时代"主题图谱',
          //主标题文本，'\n'指定换行
          x: 'center',
          // 水平安放位置，默认为左对齐，可选为：
          // 'center' ¦ 'left' ¦ 'right'
          // ¦ {number}（x坐标，单位px）
          y: 'bottom',
          // 垂直安放位置，默认为全图顶端，可选为：
          // 'top' ¦ 'bottom' ¦ 'center'
          // ¦ {number}（y坐标，单位px）
          //textAlign: null          // 水平对齐方式，默认根据x设置自动调整
          backgroundColor: 'rgba(0,0,0,0)',
          borderColor: '#ccc',
          // 标题边框颜色
          borderWidth: 0,
          // 标题边框线宽，单位px，默认为0（无边框）
          padding: 5,
          // 标题内边距，单位px，默认各方向内边距为5，
          // 接受数组分别设定上右下左边距，同css
          itemGap: 10,
          // 主副标题纵向间隔，单位px，默认为10，
          textStyle: {
            fontSize: 18,
            fontWeight: 'bolder',
            color: '#333' // 主标题文字颜色

          },
          subtextStyle: {
            color: '#aaa' // 副标题文字颜色

          }
        },
        // backgroundColor: '#fff',
        tooltip: {},
        animationDurationUpdate: function animationDurationUpdate(idx) {
          // 越往后的数据延迟越大
          return idx * 10;
        },
        animationEasingUpdate: 'bounceIn',
        color: ['#fff', '#fff', '#fff'],
        series: [{
          type: 'graph',
          layout: 'force',
          force: {
            repulsion: 50,
            edgeLength: 5
          },
          // roam: 'scale',
          label: {
            normal: {
              show: true
            }
          },
          data: [{
            "name": "石油类",
            "value": 2373,
            "symbolSize": (40 + Math.random() * 10).toFixed(0),
            "draggable": true,
            "itemStyle": {
              "normal": {
                "shadowBlur": 100,
                "shadowColor": colorList[0],
                "color": colorList[0]
              }
            }
          }, {
            "name": "生活需氧量",
            "value": 5449,
            "symbolSize": (40 + Math.random() * 10).toFixed(0),
            "draggable": true,
            "itemStyle": {
              "normal": {
                "shadowBlur": 100,
                "shadowColor": colorList[1],
                "color": colorList[1]
              }
            }
          }, {
            "name": "ph",
            "value": 2289,
            "symbolSize": (40 + Math.random() * 10).toFixed(0),
            "draggable": true,
            "itemStyle": {
              "normal": {
                "shadowBlur": 100,
                "shadowColor": colorList[2],
                "color": colorList[2]
              }
            }
          }, {
            "name": "化学需氧量",
            "value": 2289,
            "symbolSize": (40 + Math.random() * 10).toFixed(0),
            "draggable": true,
            "itemStyle": {
              "normal": {
                "shadowBlur": 100,
                "shadowColor": colorList[2],
                "color": colorList[3]
              }
            }
          }, {
            "name": "石油类1",
            "value": 2373,
            "symbolSize": (40 + Math.random() * 10).toFixed(0),
            "draggable": true,
            "itemStyle": {
              "normal": {
                "shadowBlur": 100,
                "shadowColor": colorList[0],
                "color": colorList[4]
              }
            }
          }, {
            "name": "生活需氧量1",
            "value": 5449,
            "symbolSize": (40 + Math.random() * 10).toFixed(0),
            "draggable": true,
            "itemStyle": {
              "normal": {
                "shadowBlur": 100,
                "shadowColor": colorList[1],
                "color": colorList[5]
              }
            }
          }, {
            "name": "ph1",
            "value": 2289,
            "symbolSize": (40 + Math.random() * 10).toFixed(0),
            "draggable": true,
            "itemStyle": {
              "normal": {
                "shadowBlur": 100,
                "shadowColor": colorList[2],
                "color": colorList[6]
              }
            }
          }, {
            "name": "化学需氧量1",
            "value": 2289,
            "symbolSize": (40 + Math.random() * 10).toFixed(0),
            "draggable": true,
            "itemStyle": {
              "normal": {
                "shadowBlur": 100,
                "shadowColor": colorList[2],
                "color": colorList[7]
              }
            }
          }, {
            "name": "石油类2",
            "value": 2373,
            "symbolSize": (40 + Math.random() * 10).toFixed(0),
            "draggable": true,
            "itemStyle": {
              "normal": {
                "shadowBlur": 100,
                "shadowColor": colorList[0],
                "color": colorList[8]
              }
            }
          }, {
            "name": "生活需氧量2",
            "value": 5449,
            "symbolSize": (40 + Math.random() * 10).toFixed(0),
            "draggable": true,
            "itemStyle": {
              "normal": {
                "shadowBlur": 100,
                "shadowColor": colorList[1],
                "color": colorList[1]
              }
            }
          }, {
            "name": "ph2",
            "value": 2289,
            "symbolSize": (40 + Math.random() * 10).toFixed(0),
            "draggable": true,
            "itemStyle": {
              "normal": {
                "shadowBlur": 100,
                "shadowColor": colorList[2],
                "color": colorList[2]
              }
            }
          }, {
            "name": "化学需氧量2",
            "value": 2289,
            "symbolSize": (40 + Math.random() * 10).toFixed(0),
            "draggable": true,
            "itemStyle": {
              "normal": {
                "shadowBlur": 100,
                "shadowColor": colorList[2],
                "color": colorList[2]
              }
            }
          }]
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      myChart.on('click', function (params) {// console.log(params);
        // window.open(params.data.url);
      });

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};